import * as React from "react"

const DefaultCompanyIcon = (props: any) => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width={40} height={40} rx={4} fill="#F4F2F6" />
        <path
            d="M5 6.37C5 5.612 5.613 5 6.37 5h17.26c.757 0 1.37.613 1.37 1.37v28.493a.137.137 0 0 1-.137.137H5.137A.137.137 0 0 1 5 34.863V6.37Z"
            fill="#8C8594"
        />
        <path d="M17 26.25h-4a.5.5 0 0 0-.5.5V35h5v-8.25a.5.5 0 0 0-.5-.5Z" fill="#fff" />
        <rect x={17.5} y={20} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <rect x={8.75} y={20} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <rect x={17.5} y={13.75} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <rect x={8.75} y={13.75} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <rect x={17.5} y={7.5} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <rect x={8.75} y={7.5} width={3.75} height={3.75} rx={0.4} fill="#fff" />
        <path
            d="M25 18.386c0-.49.396-.886.886-.886h8.228c.49 0 .886.396.886.886V34.91c0 .05-.04.089-.089.089H25.09a.089.089 0 0 1-.089-.089V18.386Z"
            fill="#D1CED4"
        />
        <path
            d="M28.125 21.65c0-.22.18-.4.4-.4h2.95c.22 0 .4.18.4.4v2.95a.4.4 0 0 1-.4.4h-2.95a.4.4 0 0 1-.4-.4v-2.95ZM28.125 27.9c0-.22.18-.4.4-.4h2.95c.22 0 .4.18.4.4v2.95a.4.4 0 0 1-.4.4h-2.95a.4.4 0 0 1-.4-.4V27.9Z"
            fill="#fff"
        />
    </svg>
)

export default DefaultCompanyIcon
